const turquoiseColor = '#0FF2B2';
export const particlesConfiguration = 
{
  background: {
    color: {
      value: '#0F1232'
    }
  },
  particles: {
    number: {
      value: 30,
      density: {
        enable: true,
        value_area: 1200 }
    },
    color: {
      value: turquoiseColor },
    shape: {
      type: 'circle',
      stroke: {
        width: 0,
        color: '#FFFFFF' },
      polygon: { nb_sides: 5 }
    },
    opacity: {
      value: 0.49718263175339766,
      random: false,
      anim: {
        enable: false,
        speed: 1,
        opacity_min: 0.1,
        sync: false }
    },
    size: {
      value: 2,
      random: true,
      anim: {
        enable: false,
        speed: 0.1,
        size_min: 0.1,
        sync: false }
    },
    links: {
      enable: true,
      distance: 150,
      color: turquoiseColor,
      opacity: 0.2, width: 1 },
    move: {
      enable: true,
      speed: 6,
      direction: 'none',
      random: true,
      straight: false,
      out_mode: 'out',
      bounce: false,
      attract: {
        enable: false,
        rotateX: 100,
        rotateY: 200 }
    }
  },
  detectRetina: true
};
